import { useState } from 'react';

/**
 * Whether a share is running on this screen, from the callbacks the screen already raises: a share
 * starts just before the first grant is sent, and ends when an action stops without handing on
 * (after a hand-on the screen is left, so it stays true). Passes each call on to the caller's own.
 */
export function useShareInFlight(onShareStarted?: () => void, onShareEnded?: () => void) {
  const [isSharing, setIsSharing] = useState(false);
  return {
    isSharing,
    onShareStarted: () => {
      setIsSharing(true);
      onShareStarted?.();
    },
    onShareEnded: () => {
      setIsSharing(false);
      onShareEnded?.();
    },
  };
}
